import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiUpdatePollRequestBody,
  IApiUpdatePollResponseBody,
} from '../PollsApi.types';
import { useApi } from '~/lib/api/useApi';
import { pollQueryKeyFactory } from './usePollQuery';
import { pollsQueryKeyFactory } from './usePollsQuery';

export type IUseUpdatePollMutationValues = {
  appId: string;
  pollId: string;
  body: IApiUpdatePollRequestBody;
};

export const useUpdatePollMutation = (): UseMutationResult<
  IApiUpdatePollResponseBody,
  unknown,
  IUseUpdatePollMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) =>
      api.polls.update(values.appId, values.pollId, values.body),
    onSuccess: async (updatedPoll, values) => {
      queryClient.setQueryData(
        pollQueryKeyFactory({
          ...values,
          pollId: updatedPoll._id,
        })!,
        updatedPoll,
      );
      await queryClient.invalidateQueries({
        queryKey: pollsQueryKeyFactory(),
      });
    },
  });
};
